/**
 * Scroll-restore helpers for header chrome state.
 * Fixed chrome heights come from Liquid CSS in `section-announcement_bar.liquid`
 * and inline scripts in `main-header.liquid` — never remeasured here (avoids FWM jump).
 */
class HeaderHeightsSync {
  static sync() {
    const root = document.documentElement.style;
    const header = document.getElementById('header');
    if (!header) return;

    const headerHeight = Math.max(0, Math.round(header.offsetHeight));
    if (headerHeight <= 0) return;

    const px = `${headerHeight}px`;
    root.setProperty('--header-height', px);
    root.setProperty('--submenu-position', px);
    root.setProperty('--header-dynamic-height', px);
  }

  static applyHeaderStateForScrollY(scrollY) {
    const header = document.getElementById('header');
    if (!header) return;

    const atScrollTop = scrollY < 1;
    if (!atScrollTop) {
      header.classList.add('Header--Scrolled');
      header.classList.remove('Header--Transparent');
      return;
    }

    header.classList.remove('Header--Scrolled');
    const transparentSetting =
      getComputedStyle(document.documentElement).getPropertyValue('--header-is-transparent').trim() ===
      '1';
    if (transparentSetting) {
      header.classList.add('Header--Transparent');
    }

    globalThis.themeUpdateFwmTextOffset?.();
  }

  static #readSavedScrollY() {
    try {
      const raw = sessionStorage.getItem(
        `theme:scroll-y:${location.pathname}${location.search}`
      );
      const y = raw ? parseInt(raw, 10) : 0;
      return Number.isFinite(y) && y > 0 ? y : 0;
    } catch {
      return 0;
    }
  }

  static applyPendingScrollRestoreHeaderState() {
    if (document.documentElement.getAttribute('data-scroll-restore-pending') !== '1') return;

    const savedY = HeaderHeightsSync.#readSavedScrollY();
    if (savedY < 1) return;

    document.documentElement.style.setProperty('--header-is-transparent', '0');
    HeaderHeightsSync.applyHeaderStateForScrollY(savedY);
  }

  static init() {
    HeaderHeightsSync.applyPendingScrollRestoreHeaderState();
    window.themeSyncLayoutHeights = () => HeaderHeightsSync.sync();
  }
}

HeaderHeightsSync.init();
